import React from 'react';
import _ from 'lodash';
import { Dialog } from '@mui/material';
import './../../../assets/style/CallBookingCalendar.css';
import CallBookingCalendar from './CallBookingCalendar';
import CommonModalHeader from '../../../components/DialogUi/CommonModalHeader';

interface CallBookingModalProps {
  title?: string;
  handleCloseModal: () => void;
  openFlag: boolean;
  chatProfileName: string;
  chatType: string;
  threadParticipantsUsers: any[];
  pageName: string;
  bookedCallDetails: any;
  isCallEditing?: boolean;
  objectiveDetails?: any;
  onMeetingScheduled?: (meetingDetails: any) => void;
  handleCloseRecruitMentor?: () => void;
}

const CallBookingModal: React.FC<CallBookingModalProps> = ({
  title,
  handleCloseModal,
  openFlag,
  chatProfileName,
  threadParticipantsUsers,
  chatType,
  pageName,
  bookedCallDetails,
  isCallEditing = false,
  objectiveDetails,
  onMeetingScheduled,
  handleCloseRecruitMentor
}) => {
  return (
    <Dialog
      open={openFlag}
      onClose={() => handleCloseModal()}
      scroll="body"
      data-testid="call-booking-modal"
      PaperProps={{ className: 'CallBookingDialogPaper' }}
    >
      <div className="CallBookingWrapper">
        <CommonModalHeader
          handleCloseModal={handleCloseModal}
          title={pageName === 'Calendar' ? 'Schedule New Meeting' : `Book time with ${chatProfileName}`}
        />

        <div className="CallBookingContent">
          <CallBookingCalendar
            title={title}
            onClose={() => handleCloseModal()}
            channelNaame={chatProfileName}
            threadParticipantsUsers={threadParticipantsUsers}
            chatType={chatType}
            pageName={pageName}
            bookedCallDetails={bookedCallDetails}
            isCallEditing={isCallEditing}
            objectiveDetails={objectiveDetails}
            onMeetingScheduled={onMeetingScheduled}
            handleCloseRecruitMentor={handleCloseRecruitMentor}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default CallBookingModal;
